import { PortalWrapper } from 'app/App.styles';
import styled, { from } from 'theme';

export const ChangePasswordWrapper = styled(PortalWrapper)`
  .page-header {
    justify-content: center;
    margin-bottom: 2rem;
  }

  .change-password__content {
    padding: 1rem 0;

    ${from('md')} {
      padding: 4rem 0;
    }

    .form {
      padding: 0 3rem;
    }
  }
`;
